export default (state = [], action) => {
    switch (action.type) {
        case 'CATEGORIES_FETCH_SUCCESS':
            return action.categories;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/categoryReducers.js